
<template>

  <div class="ui stackable grid">

    <!-- Title and ehdaa -->
    <div class="eleven wide column">
      <span class="ui almarai yellow big text">{{ work.title }}</span>
      <br>
      <span class="ui almarai white big header">
        <span class="ui almarai white tiny text">يهدى هذا العمل إلى:</span>
        <br>
        {{ work.ehdaa }}
      </span>
    </div>

    <!-- Counter -->
    <div class="five wide column">
      <Counter v-if="!work.khatma" :work="work" :currentTime="currentTime" />
    </div>

  </div>

</template>

<script>
import Counter from '@/components/Works/Counter';

export default {

  name: 'WorkItem',
  components: {

    Counter

  },
  props: {

    work: Object,
    currentTime: Date

  }

}
</script>

<style scoped>
.white {
  color: white !important;
}
</style>
